import { render, staticRenderFns } from "./DetailBroadcastMessage.vue?vue&type=template&id=16356d83&scoped=true"
import script from "./DetailBroadcastMessage.vue?vue&type=script&lang=js"
export * from "./DetailBroadcastMessage.vue?vue&type=script&lang=js"
import style0 from "./DetailBroadcastMessage.vue?vue&type=style&index=0&id=16356d83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16356d83",
  null
  
)

export default component.exports